/** These strings aren't customer-facing: these don't need to be localized. */
export const EMAIL_CONFIRMATION = {
  name: 'Ash',
  confirmUrl:
    'https://staging.degreed.dev/develop/#/CANT_GENERATE_A_DEMO_LINK_FOR_THIS',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/8/8c/Pok%C3%A9mon.svg/revision/latest/scale-to-width-down/300?cb=20180728053656',
};
